(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var ROOT = document.querySelector('[data-cart-drawer]');
    if (!ROOT) return;
    if (ROOT.dataset.cartDrawerInit === 'true') return;
    ROOT.dataset.cartDrawerInit = 'true';

    var panel = ROOT.querySelector('.cart-drawer__panel');
    var itemsList = ROOT.querySelector('[data-cart-items]');
    var emptyBox = ROOT.querySelector('[data-cart-empty]');
    var footer = ROOT.querySelector('[data-cart-footer]');
    var countLabel = ROOT.querySelector('[data-cart-count-label]');
    var template = ROOT.querySelector('[data-cart-item-template]');
    var headerCountEl = document.querySelector('.header__cart-count');
    var headerCartLink = document.querySelector('[data-cart-drawer-open]');

    var lastFocus = null;
    var SHOP_CURRENCY = ROOT.dataset.shopCurrency || 'EUR';
    var PACK_PROMO_ENABLED = ROOT.dataset.packPromoEnabled === 'true';
    var PACK_PROMO_MSG = ROOT.dataset.packPromoMsg || '';

    function formatMoney(cents, currency) {
      var amount = Math.round(cents) / 100;
      var code = currency || SHOP_CURRENCY;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: code,
          currencyDisplay: 'narrowSymbol'
        }).format(amount);
      } catch (e) {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: code
        }).format(amount);
      }
    }

    function variantLabel(line) {
      if (line.options_with_values && line.options_with_values.length) {
        for (var i = 0; i < line.options_with_values.length; i++) {
          var o = line.options_with_values[i];
          if (o && o.name === 'Format' && o.value) {
            return o.value + ' X 33CL';
          }
        }
      }
      if (line.variant_title && line.variant_title !== 'Default Title') {
        return String(line.variant_title).toUpperCase();
      }
      return '';
    }

    function thumbSrc(line) {
      var raw = line.image || line.featured_image && line.featured_image.url;
      if (!raw) return '';
      if (raw.indexOf('_280x280') !== -1 || raw.indexOf('?width=') !== -1) return raw;
      return raw.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_280x280$1$2');
    }

    function render(cart) {
      var count = cart.item_count || 0;
      countLabel.textContent = count + ' item' + (count === 1 ? '' : 's');

      if (headerCountEl) {
        if (count > 0) {
          headerCountEl.textContent = count;
          headerCountEl.hidden = false;
        } else {
          headerCountEl.hidden = true;
        }
      }
      if (headerCartLink) {
        headerCartLink.setAttribute(
          'aria-label',
          'Cart, ' + count + ' item' + (count === 1 ? '' : 's')
        );
      }

      itemsList.innerHTML = '';

      if (count === 0) {
        emptyBox.hidden = false;
        footer.hidden = true;
        return;
      }
      emptyBox.hidden = true;
      footer.hidden = false;

      var items = cart.items || [];
      for (var i = 0; i < items.length; i++) {
        itemsList.appendChild(buildItem(items[i], cart));
      }
    }

    function buildItem(line, cart) {
      var node = template.content.firstElementChild.cloneNode(true);
      node.dataset.lineKey = line.key;

      var img = node.querySelector('[data-item-thumb]');
      var link = node.querySelector('[data-item-link]');
      var src = thumbSrc(line);
      if (src) {
        img.src = src;
        img.alt = line.product_title || '';
      } else {
        img.removeAttribute('src');
        img.alt = '';
      }
      if (line.url) link.href = line.url;

      node.querySelector('[data-item-title]').textContent = line.product_title || '';
      node.querySelector('[data-item-variant]').textContent = variantLabel(line);
      node.querySelector('[data-item-qty]').textContent = line.quantity;
      node.querySelector('[data-item-price]').textContent = formatMoney(line.final_line_price, cart.currency);

      var priceWasEl = node.querySelector('[data-item-price-was]');
      if (priceWasEl) {
        if (line.original_line_price > line.final_line_price) {
          priceWasEl.textContent = formatMoney(line.original_line_price, cart.currency);
          priceWasEl.hidden = false;
        } else {
          priceWasEl.hidden = true;
        }
      }

      var promoEl = node.querySelector('[data-line-promo]');
      if (promoEl) {
        var allocs = line.line_level_discount_allocations || [];
        if (allocs.length) {
          var parts = allocs.map(function (a) {
            var title = (a.discount_application && a.discount_application.title) || a.title || '';
            return title + ' −' + formatMoney(a.amount, cart.currency);
          });
          promoEl.textContent = parts.join(' · ');
          promoEl.hidden = false;
        } else if (PACK_PROMO_ENABLED && PACK_PROMO_MSG) {
          promoEl.textContent = PACK_PROMO_MSG;
          promoEl.hidden = false;
        } else {
          promoEl.hidden = true;
        }
      }

      var dec = node.querySelector('[data-cart-decrease]');
      if (line.quantity <= 1) dec.setAttribute('disabled', 'disabled');

      return node;
    }

    function fetchCart() {
      return fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      }).then(function (res) { return res.json(); });
    }

    function changeLine(key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (res) { return res.json(); });
    }

    function refresh() {
      return fetchCart().then(render).catch(function () {});
    }

    function open() {
      lastFocus = document.activeElement;
      ROOT.hidden = false;
      ROOT.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('cart-drawer-open');
      document.body.classList.add('cart-drawer-open');
      requestAnimationFrame(function () {
        ROOT.classList.add('is-open');
      });
      setTimeout(function () {
        var focusTarget =
          ROOT.querySelector('[data-cart-drawer-close]') ||
          panel;
        if (focusTarget) focusTarget.focus();
      }, 50);
    }

    function close() {
      ROOT.classList.remove('is-open');
      ROOT.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cart-drawer-open');
      document.body.classList.remove('cart-drawer-open');
      var hideAfter = function () {
        ROOT.hidden = true;
        panel.removeEventListener('transitionend', onEnd);
      };
      var onEnd = function (e) {
        if (e.target === panel && e.propertyName === 'transform') hideAfter();
      };
      panel.addEventListener('transitionend', onEnd);
      setTimeout(hideAfter, 400);
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus(); } catch (e) {}
      }
    }

    ROOT.querySelector('[data-cart-drawer-backdrop]').addEventListener('click', close);
    ROOT.querySelector('[data-cart-drawer-close]').addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && ROOT.classList.contains('is-open')) {
        e.preventDefault();
        close();
      }
    });

    var discover = ROOT.querySelector('[data-cart-discover]');
    if (discover) {
      discover.addEventListener('click', function () {
        close();
      });
    }

    itemsList.addEventListener('click', function (e) {
      var item = e.target.closest('.cart-drawer__item');
      if (!item) return;
      var key = item.dataset.lineKey;
      if (!key) return;

      var inc = e.target.closest('[data-cart-increase]');
      var dec = e.target.closest('[data-cart-decrease]');
      var rm = e.target.closest('[data-cart-remove]');

      if (!inc && !dec && !rm) return;

      var qtyEl = item.querySelector('[data-item-qty]');
      var current = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;
      var next = current;
      if (inc) next = current + 1;
      else if (dec) next = Math.max(0, current - 1);
      else if (rm) next = 0;

      changeLine(key, next).then(render).catch(function () {});
    });

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-cart-drawer-open]');
      if (!trigger) return;
      e.preventDefault();
      refresh().then(open);
    });

    window.addEventListener('cart:added', function () {
      refresh().then(open);
    });

    refresh();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-login"]) return;
  try {
    
  if (!window.__authRecoverInit) {
    window.__authRecoverInit = true;
    document.addEventListener('click', function (event) {
      var open = event.target.closest('[data-recover-open]');
      var close = event.target.closest('[data-recover-close]');
      if (open) {
        var wrapOpen = open.closest('[data-auth-toggle]');
        if (wrapOpen) wrapOpen.classList.add('auth--recover');
      } else if (close) {
        var wrapClose = close.closest('[data-auth-toggle]');
        if (wrapClose) wrapClose.classList.remove('auth--recover');
      }
    });
    document.addEventListener('DOMContentLoaded', function () {
      var success = document.querySelector('.auth__recover-success');
      if (success) {
        var wrap = success.closest('[data-auth-toggle]');
        if (wrap) wrap.classList.add('auth--recover');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
function initHeader(scope) {
  var root = scope || document;
  root.querySelectorAll('.header__inner').forEach(function(inner) {
    if (inner.dataset.headerInit === 'true') return;
    inner.dataset.headerInit = 'true';

    var burger = inner.querySelector('.header__burger');
    if (!burger) return;

    function setOpen(open) {
      inner.dataset.menuOpen = open ? 'true' : 'false';
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
    }

    burger.addEventListener('click', function() {
      setOpen(inner.dataset.menuOpen !== 'true');
    });

    // Accordéon sous-menu produits (mobile) — indépendant du toggle burger.
    inner.querySelectorAll('.header__msub-parent').forEach(function(parent) {
      parent.addEventListener('click', function() {
        var sub = parent.nextElementSibling;
        if (!sub || !sub.classList.contains('header__msub')) return;
        var open = parent.getAttribute('aria-expanded') !== 'true';
        parent.setAttribute('aria-expanded', open ? 'true' : 'false');
        sub.classList.toggle('is-open', open);
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && inner.dataset.menuOpen === 'true') {
        setOpen(false);
        burger.focus();
      }
    });
  });
}

// Expose la hauteur RÉELLE du header en variable CSS globale
// (--header-height-actual) → la nav verticale desktop + le sticky-atc s'y calent.
// SENS INCHANGÉ : c'est la hauteur de .header__inner (le header SEUL), pas la pile.
function setHeaderHeightVar() {
  var inner = document.querySelector('.header__inner');
  if (!inner) return;
  var h = Math.round(inner.getBoundingClientRect().height);
  document.documentElement.style.setProperty('--header-height-actual', h + 'px');
}

// --ab-sticky-height : hauteur de l'announcement bar SI elle est épinglée
// (data-pinned="true"), sinon 0px. Sert au header (son top se décale dessous).
// Announcement désactivée → le markup .announcement-bar n'existe pas → 0px.
function setAbStickyHeightVar() {
  var ab = document.querySelector('.announcement-bar');
  var h = (ab && ab.dataset.pinned === 'true')
    ? Math.round(ab.getBoundingClientRect().height)
    : 0;
  document.documentElement.style.setProperty('--ab-sticky-height', h + 'px');
}

// --stack-bottom : bas RÉEL du header en coordonnées viewport
// (getBoundingClientRect().bottom du wrapper de section <header>). Suit la pile
// announcement épinglée + header dans les DEUX modes, à n'importe quel scroll :
//   - épinglée  : pile collée en haut → bottom = ab + header (constant).
//   - défile    : à scroll 0 le header est sous l'announcement (bottom = ab + header),
//                 puis l'announcement sort de l'écran et bottom → header seul.
// La nav saveurs PDP (mobile + canette desktop) s'y cale → toujours pile sous le header.
// Announcement désactivée → bottom = hauteur header (cas géré naturellement).
function setStackBottomVar() {
  var inner = document.querySelector('.header__inner');
  if (!inner) return;
  var headerEl = inner.closest('header') || inner;
  var bottom = Math.round(headerEl.getBoundingClientRect().bottom);
  document.documentElement.style.setProperty('--stack-bottom', bottom + 'px');
}

// --stack-bottom change au scroll → throttle via rAF.
var stackBottomTicking = false;
function requestStackBottom() {
  if (stackBottomTicking) return;
  stackBottomTicking = true;
  requestAnimationFrame(function() {
    stackBottomTicking = false;
    setStackBottomVar();
  });
}

function measureHeaderVars() {
  setHeaderHeightVar();
  setAbStickyHeightVar();
  setStackBottomVar();
}

function observeHeaderHeight() {
  var inner = document.querySelector('.header__inner');
  if (!inner) return;
  measureHeaderVars();
  // ResizeObserver couvre reflow (chargement logo/police) + changements de hauteur
  // au breakpoint, sans listener resize bruyant.
  if ('ResizeObserver' in window && inner.dataset.heightObserved !== 'true') {
    inner.dataset.heightObserved = 'true';
    new ResizeObserver(measureHeaderVars).observe(inner);
  }
  // L'announcement bar peut changer de hauteur (texte qui passe sur 2 lignes au
  // resize) → l'observer aussi pour garder --ab-sticky-height / --stack-bottom justes.
  var ab = document.querySelector('.announcement-bar');
  if (ab && 'ResizeObserver' in window && ab.dataset.heightObserved !== 'true') {
    ab.dataset.heightObserved = 'true';
    new ResizeObserver(function() { setAbStickyHeightVar(); setStackBottomVar(); }).observe(ab);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { initHeader(); observeHeaderHeight(); });
} else {
  initHeader();
  observeHeaderHeight();
}

// Mesure après chargement complet (logo/police peuvent changer la hauteur) + au resize.
window.addEventListener('load', measureHeaderVars);
window.addEventListener('resize', measureHeaderVars);
// Le bas de la pile bouge au scroll (announcement non-épinglée qui défile).
window.addEventListener('scroll', requestStackBottom, { passive: true });

document.addEventListener('shopify:section:load', function(e) {
  initHeader(e.target);
  observeHeaderHeight();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function () {
    var ROOT = document.querySelector('[data-main-cart-root]');
    if (!ROOT) return;
    if (ROOT.dataset.mainCartInit === 'true') return;
    ROOT.dataset.mainCartInit = 'true';

    var sectionId = ROOT.dataset.sectionId;
    var headerCountEl = document.querySelector('.header__cart-count');
    var headerCartLink = document.querySelector('[data-cart-drawer-open]');

    /* Mêmes endpoints que le cart-drawer : /cart/change.js.
       On ajoute le paramètre `sections` (Section Rendering API) pour re-rendre
       la section côté serveur et conserver le money filter Liquid partout. */
    function changeLine(key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity,
          sections: sectionId,
          sections_url: window.location.pathname
        })
      }).then(function (res) { return res.json(); });
    }

    function updateHeaderCount(count) {
      if (headerCountEl) {
        if (count > 0) {
          headerCountEl.textContent = count;
          headerCountEl.hidden = false;
        } else {
          headerCountEl.hidden = true;
        }
      }
      if (headerCartLink) {
        headerCartLink.setAttribute(
          'aria-label',
          'Cart, ' + count + ' item' + (count === 1 ? '' : 's')
        );
      }
    }

    function applyResponse(cart) {
      updateHeaderCount(cart.item_count || 0);

      var html = cart.sections && cart.sections[sectionId];
      if (!html) {
        window.location.reload();
        return;
      }
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-main-cart]');
      var current = ROOT.querySelector('[data-main-cart]');
      if (fresh && current) {
        current.innerHTML = fresh.innerHTML;
      } else {
        window.location.reload();
      }
    }

    ROOT.addEventListener('click', function (e) {
      var item = e.target.closest('.cart-drawer__item');
      if (!item) return;
      var key = item.dataset.lineKey;
      if (!key) return;

      var inc = e.target.closest('[data-cart-increase]');
      var dec = e.target.closest('[data-cart-decrease]');
      var rm = e.target.closest('[data-cart-remove]');
      if (!inc && !dec && !rm) return;

      var qtyEl = item.querySelector('[data-item-qty]');
      var current = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;
      var next = current;
      if (inc) next = current + 1;
      else if (dec) next = Math.max(0, current - 1);
      else if (rm) next = 0;

      changeLine(key, next).then(applyResponse).catch(function () {
        window.location.reload();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  class NewsletterPopup extends HTMLElement {
    constructor() {
      super();
      this.card = this.querySelector('.nlpop__card');
      this.storageKey = 'nlpop:' + this.id;
      this.onKeydown = this.onKeydown.bind(this);
    }

    connectedCallback() {
      this.querySelectorAll('[data-nlpop-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });

      const submit = this.querySelector('.nlpop__submit');
      if (submit) {
        submit.addEventListener('click', () => submit.classList.add('is-sending'));
      }

      const designMode = window.Shopify && window.Shopify.designMode;

      if (this.hasAttribute('data-force-open') || designMode) {
        this.open();
        return;
      }

      if (this.dismissed()) return;

      const delay = (parseFloat(this.getAttribute('data-open-delay')) || 0) * 1000;
      this.timer = window.setTimeout(() => this.open(), delay);
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      document.removeEventListener('keydown', this.onKeydown);
    }

    reappearDays() {
      return parseFloat(this.getAttribute('data-reappear-days')) || 0;
    }

    dismissed() {
      const days = this.reappearDays();
      if (days <= 0) return false;
      try {
        const closedAt = parseInt(window.localStorage.getItem(this.storageKey), 10);
        if (!closedAt) return false;
        const elapsed = Date.now() - closedAt;
        return elapsed < days * 86400000;
      } catch (e) {
        return false;
      }
    }

    remember() {
      try {
        window.localStorage.setItem(this.storageKey, String(Date.now()));
      } catch (e) {
        /* storage unavailable — fail open */
      }
    }

    open() {
      if (this.isOpen) return;
      this.isOpen = true;
      this.hidden = false;
      document.addEventListener('keydown', this.onKeydown);
      requestAnimationFrame(() => this.classList.add('is-open'));
      const input = this.querySelector('.nlpop__input');
      if (input) {
        window.setTimeout(() => input.focus(), 350);
      }
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-open');
      this.remember();
      document.removeEventListener('keydown', this.onKeydown);
      const finish = () => {
        this.hidden = true;
        this.card.removeEventListener('transitionend', finish);
      };
      this.card.addEventListener('transitionend', finish);
      window.setTimeout(finish, 400);
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.close();
    }
  }

  if (!customElements.get('newsletter-popup')) {
    customElements.define('newsletter-popup', NewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-flavors"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.pdp');
    for (var i = 0; i < sections.length; i++) initPdp(sections[i]);

    function initPdp(section) {
      if (section.dataset.pdpInit === 'true') return;
      section.dataset.pdpInit = 'true';

      var navItems = Array.prototype.slice.call(section.querySelectorAll('.pdp-nav-item:not([data-dpack-nav])'));
      var flavors = Array.prototype.slice.call(section.querySelectorAll('.pdp-flavor'));
      if (navItems.length === 0 || flavors.length === 0) return;

      section._dpackActive = !!document.querySelector('.dpack');

      bindNavClicks(section, navItems);
      bindArrows(section, navItems);
      setupNavVisibility(section);
      setupBuyArea(section);
      setupMobilePills(section, flavors, navItems);
      setupResponsiveMode(section, flavors, navItems);
      setupDpackNav(section);
      setupBarContentMask(section);

      // Anchor-based active state is the SINGLE SOURCE OF TRUTH for the
      // mobile pills/nav. Run it LAST so it overrides any active state left
      // by the load-time side effects above (mobile-mode apply, pill boot,
      // responsive re-check) — the writers that previously left BERRY active
      // at load even though the Discovery Pack sits at the top of the page.
      // Three scheduling hooks guarantee it gets the last word:
      //   • setTimeout(0): registered AFTER setupResponsiveMode's own
      //     setTimeout(0) re-check, so it fires strictly after that re-applies
      //     mobile mode (and re-runs _centerPillInBar, the BERRY culprit).
      //   • rAF: after the first paint, once layout is settled (rects real).
      //   • window 'load': backstop for restored scroll (deep link / back-nav).
      // `true` forces the write even when the computed state already equals
      // section._dpackActive, so a stale side-effect pill still gets corrected.
      requestAnimationFrame(function () { determineActiveAnchor(section, true); });
      setTimeout(function () { determineActiveAnchor(section, true); }, 0);
      if (document.readyState !== 'complete') {
        window.addEventListener('load', function () { determineActiveAnchor(section, true); }, { once: true });
      }
    }

    // determineActiveAnchor — single source of truth for the mobile pills/nav
    // active state. Decides which "anchor" section currently occupies the top
    // of the viewport (just under the header + sticky bar, at y≈ANCHOR_Y) and
    // sets the active pill from THAT, instead of trusting any setup's side
    // effect. Anchors: the Discovery Pack section (.dpack) and this PDP
    // flavors section. They're sorted by their live viewport top (= document
    // order at any scroll position), and the active one is the LAST anchor
    // whose top has reached or passed the anchor line. At scroll-top → dpack;
    // scrolled into the flavors section → the currently-selected flavor.
    // Mobile only — desktop keeps its pin / observeFlavors model untouched.
    var ANCHOR_Y = 125;
    function determineActiveAnchor(section, force) {
      if (!isMobile()) return;
      var apply = section._applyDpackState;
      if (typeof apply !== 'function') return;

      var anchors = [];
      var dpack = document.querySelector('.dpack');
      if (dpack) anchors.push({ el: dpack, dpack: true });
      anchors.push({ el: section, dpack: false });
      anchors.sort(function (a, b) {
        return a.el.getBoundingClientRect().top - b.el.getBoundingClientRect().top;
      });

      var chosen = anchors[0];
      for (var i = 0; i < anchors.length; i++) {
        if (anchors[i].el.getBoundingClientRect().top <= ANCHOR_Y + 1) chosen = anchors[i];
      }

      // Guard against thrashing the bar's smooth recenter on every scroll
      // tick; force on the load-time calls so a wrong side-effect pill is
      // overwritten even when the boolean already matches.
      if (force || section._dpackActive !== chosen.dpack) apply(chosen.dpack);
    }

    // setupBarContentMask: keeps a viewport-anchored transparent band on
    // the scrolling content of both .pdp-stack (PDP flavors) and
    // .dpack-overlay (Discovery Pack). The band stays glued to the bar
    // zone (viewport y=80→125) regardless of page scroll by recomputing
    // each element's mask offset on every scroll/resize. CSS uses these
    // vars (--bar-mask-start / --bar-mask-end) inside a mask-image:
    // linear-gradient with hard edges, so the content gets cut net at
    // the bar's top + bottom edges. Result: through the bar zone the user
    // always sees the section's REAL background (saveur gradient on PDP,
    // orange image on dpack), zero added color, zero band possible.
    // Mobile-only — desktop has no bar; the listeners short-circuit there
    // so no perf cost. */
    function setupBarContentMask(section) {
      var BAR_TOP = 79;
      var BAR_BOTTOM = 124;
      var targets = null;

      function collect() {
        // Resolved lazily so the stack is guaranteed in the DOM by the time
        // we read. Re-collect on resize in case a section was dynamically
        // rebuilt by the responsive-mode switch.
        // NOTE: the Discovery Pack drives its OWN mask (see discovery-pack.liquid)
        // so it no longer depends on this PDP section's init running — if the
        // PDP had no blocks, initPdp returns early and this never ran, leaving
        // the dpack content uncut under the bar.
        targets = [];
        var stack = section.querySelector('.pdp-stack');
        if (stack) targets.push(stack);
      }

      function update() {
        if (!isMobile()) {
          // Desktop: clear vars so the mask-image gradient collapses to
          // a fully-opaque no-op (start==end==0 → no transparent zone).
          if (!targets) return;
          for (var i = 0; i < targets.length; i++) {
            targets[i].style.removeProperty('--bar-mask-start');
            targets[i].style.removeProperty('--bar-mask-end');
          }
          return;
        }
        if (!targets) collect();
        for (var j = 0; j < targets.length; j++) {
          var el = targets[j];
          var top = el.getBoundingClientRect().top;
          // Convert viewport y of the bar's top/bottom into the
          // element's own local y. Negative or out-of-box values are
          // harmless — the mask just has no visible transparent band
          // when the element isn't crossing the bar zone.
          el.style.setProperty('--bar-mask-start', (BAR_TOP - top) + 'px');
          el.style.setProperty('--bar-mask-end', (BAR_BOTTOM - top) + 'px');
        }
      }

      collect();
      update();
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', function () {
        collect();
        update();
      });
    }

    // ========================================================
    // RESPONSIVE MODE — mobile (< 768px) vs desktop (≥ 768px).
    // Mobile = single-flavor view + sticky pills nav. Desktop =
    // pin/wipe stack (unchanged). The matchMedia listener tears
    // down one mode and rebuilds the other on viewport crossing.
    // ========================================================
    var MOBILE_MQ = '(max-width: 767px)';
    function isMobile() {
      return window.matchMedia(MOBILE_MQ).matches;
    }

    function setupResponsiveMode(section, flavors, navItems) {
      function applyForCurrentViewport() {
        var wantMobile = isMobile();
        var inMobile = section.classList.contains('pdp--mobile');
        var inDesktop = section.classList.contains('pdp--pinned');
        if (wantMobile && !inMobile) {
          if (inDesktop) tearDownDesktopMode(section, flavors);
          applyMobileMode(section, flavors, navItems);
        } else if (!wantMobile && !inDesktop) {
          if (inMobile) tearDownMobileMode(section, flavors);
          applyDesktopMode(section, flavors, navItems);
        }
      }

      // Initial mode at load.
      applyForCurrentViewport();

      // Re-check on next macrotask: at the time setupResponsiveMode first
      // runs, the browser may not have stabilized the layout viewport yet,
      // so isMobile() can briefly return the wrong answer. Force a sync
      // on next tick (and again at window.load if not yet fired) so the
      // section always ends up in the correct mode without depending on a
      // matchMedia 'change' event that may never fire.
      setTimeout(applyForCurrentViewport, 0);
      if (document.readyState !== 'complete') {
        window.addEventListener('load', applyForCurrentViewport, { once: true });
      }

      var mql = window.matchMedia(MOBILE_MQ);
      // Modern browsers + legacy fallback for matchMedia change events.
      if (typeof mql.addEventListener === 'function') {
        mql.addEventListener('change', applyForCurrentViewport);
      } else if (typeof mql.addListener === 'function') {
        mql.addListener(applyForCurrentViewport);
      }
    }

    function applyMobileMode(section, flavors, navItems) {
      // Defensive cleanup — kill any ScrollTrigger associated with this
      // section and wipe any inline transforms GSAP may have applied.
      // Belt-and-suspenders: even though setupPin isn't called on mobile,
      // this guards against stray state if the page was first loaded on
      // desktop then resized down, or if GSAP code ran asynchronously.
      // Without this, a leftover transform on .pdp-can-anchor would make
      // the can appear to "animate" relative to its grid cell on scroll.
      if (window.ScrollTrigger) {
        var allST = window.ScrollTrigger.getAll();
        for (var ti = 0; ti < allST.length; ti++) {
          var trig = allST[ti];
          var trigEl = trig.trigger || trig.scroller;
          if (trigEl && section.contains(trigEl)) {
            try { trig.kill(); } catch (e) {}
          }
        }
      }
      if (section._pdpST) {
        try { section._pdpST.kill(); } catch (e) {}
        section._pdpST = null;
      }
      section._pdpScrollToFlavor = null;
      section._pdpFlavorStartPx = null;
      section.dataset.pdpPinInit = '';
      section.classList.remove('pdp--pinned');
      if (window.gsap) {
        // Clear ONLY the properties GSAP could have set (transform, opacity,
        // clip-path, z-index, x/y aliases). NEVER use clearProps:'all' —
        // it nukes the inline CSS custom properties (`--pdp-bg-start`,
        // `--pdp-bg-end`, `--pdp-accent`) that Liquid renders on each
        // .pdp-flavor, which would freeze every flavor's gradient to the
        // Berry fallback color.
        var GSAP_CLEAR = 'transform,opacity,clipPath,webkitClipPath,zIndex,x,y';
        var clearSels = ['.pdp-flavor', '.pdp-stage', '.pdp-bg',
          '.pdp-can-anchor', '.pdp-can-img', '.pdp-lower-inner', '.pdp-stack'];
        for (var cs = 0; cs < clearSels.length; cs++) {
          var els = section.querySelectorAll(clearSels[cs]);
          for (var ei = 0; ei < els.length; ei++) {
            try { window.gsap.set(els[ei], { clearProps: GSAP_CLEAR }); } catch (err) {}
          }
        }
      }

      section.classList.add('pdp--mobile');
      var pills = section.querySelectorAll('.pdp-pill:not([data-dpack-nav])');
      var activeIdx = 0;
      for (var p = 0; p < pills.length; p++) {
        if (pills[p].classList.contains('is-active')) { activeIdx = p; break; }
      }
      syncMobileActive(section, flavors, navItems, pills, activeIdx);
    }

    function tearDownMobileMode(section, flavors) {
      section.classList.remove('pdp--mobile');
      for (var i = 0; i < flavors.length; i++) {
        flavors[i].classList.remove('pdp-flavor--active', 'pdp-flavor--hidden');
      }
    }

    function applyDesktopMode(section, flavors, navItems) {
      setupPin(section, flavors, navItems);
    }

    function tearDownDesktopMode(section, flavors) {
      // Kill the active ScrollTrigger (if any) and clear cached refs.
      if (section._pdpST) {
        try { section._pdpST.kill(); } catch (e) {}
        section._pdpST = null;
      }
      section._pdpScrollToFlavor = null;
      section._pdpFlavorStartPx = null;
      section.dataset.pdpPinInit = '';
      section.classList.remove('pdp--pinned');

      // Wipe ONLY the GSAP-set properties (NOT 'all' — that would nuke the
      // per-flavor CSS custom properties from Liquid's inline style).
      if (window.gsap) {
        var GSAP_CLEAR = 'transform,opacity,clipPath,webkitClipPath,zIndex,x,y';
        for (var i = 0; i < flavors.length; i++) {
          window.gsap.set(flavors[i], { clearProps: GSAP_CLEAR });
        }
        var cans = section.querySelectorAll('.pdp-can-anchor');
        for (var c = 0; c < cans.length; c++) {
          window.gsap.set(cans[c], { clearProps: GSAP_CLEAR });
        }
        var inners = section.querySelectorAll('.pdp-lower-inner');
        for (var ii = 0; ii < inners.length; ii++) {
          window.gsap.set(inners[ii], { clearProps: GSAP_CLEAR });
        }
      }
      if (window.ScrollTrigger) {
        try { window.ScrollTrigger.refresh(); } catch (e) {}
      }
    }

    // Circular pills carousel — 4 real pills (Discovery / Berry /
    // Hibiscus / Peach) are cloned into 2 extra sets at setup time so
    // the DOM is [D B H P] [D B H P] [D B H P]. The user scrolls /
    // swipes horizontally in this 12-pill scroller; when they settle on
    // an edge-block pill (block 0 or 2), JS instantly jumps scrollLeft
    // to the equivalent middle-block pill (same neighbors on either
    // side, so the jump is visually seamless). Result: bar feels
    // infinitely circular — there's ALWAYS a neighbor visible on each
    // side of the centered active pill, including at "first" and "last".
    function setupMobilePills(section, flavors, navItems) {
      var scroller = section.querySelector('[data-pdp-pills-scroller]');
      if (!scroller) return;
      var realPills = Array.prototype.slice.call(scroller.querySelectorAll('.pdp-pill'));
      if (realPills.length === 0) return;
      var N = realPills.length;

      // Clone 2 sets (before + after). aria-hidden on clones so screen
      // readers only see the real ones; data-clone marks them so other
      // queries (setupDpackNav) can filter them out.
      var beforeFrag = document.createDocumentFragment();
      var afterFrag = document.createDocumentFragment();
      for (var k = 0; k < N; k++) {
        var p = realPills[k];
        [beforeFrag, afterFrag].forEach(function (frag) {
          var c = p.cloneNode(true);
          c.classList.remove('is-active');
          c.removeAttribute('aria-selected');
          c.setAttribute('aria-hidden', 'true');
          c.removeAttribute('id');
          c.dataset.clone = '1';
          frag.appendChild(c);
        });
      }
      scroller.insertBefore(beforeFrag, scroller.firstChild);
      scroller.appendChild(afterFrag);

      var allPills = Array.prototype.slice.call(scroller.querySelectorAll('.pdp-pill'));
      var flavorPills = realPills.filter(function (p) { return !p.matches('[data-dpack-nav]'); });
      var arrowPrev = section.querySelector('[data-pdp-pills-prev]');
      var arrowNext = section.querySelector('[data-pdp-pills-next]');

      // activeRealIdx: 0 = dpack, 1..N-1 = flavor 0..N-2.
      var activeRealIdx = 0;
      var programmatic = false;
      var scrollTimer = null;

      function detectCenteredPill() {
        var sRect = scroller.getBoundingClientRect();
        var centerX = sRect.left + sRect.width / 2;
        var closest = null, closestDist = Infinity;
        for (var i = 0; i < allPills.length; i++) {
          var pRect = allPills[i].getBoundingClientRect();
          var pCenter = pRect.left + pRect.width / 2;
          var d = Math.abs(pCenter - centerX);
          if (d < closestDist) { closestDist = d; closest = allPills[i]; }
        }
        return closest;
      }

      function updateActiveOnPills(realIdx) {
        for (var i = 0; i < allPills.length; i++) {
          allPills[i].classList.remove('is-active');
          allPills[i].setAttribute('aria-selected', 'false');
        }
        var target = realPills[realIdx];
        if (target) {
          target.classList.add('is-active');
          target.setAttribute('aria-selected', 'true');
          // Half-width drives the chevron horizontal anchors via the
          // --pdp-active-half custom property.
          section.style.setProperty('--pdp-active-half', (target.offsetWidth / 2) + 'px');
        }
      }

      function scrollToAllIdx(allIdx, smooth) {
        var pill = allPills[allIdx];
        if (!pill) return;
        programmatic = true;
        var targetLeft = pill.offsetLeft + pill.offsetWidth / 2 - scroller.clientWidth / 2;
        if (smooth) {
          scroller.scrollTo({ left: targetLeft, behavior: 'smooth' });
          setTimeout(function () { programmatic = false; }, 500);
        } else {
          scroller.scrollLeft = targetLeft;
          setTimeout(function () { programmatic = false; }, 50);
        }
      }

      function scrollToMiddleReal(realIdx, smooth) {
        scrollToAllIdx(N + realIdx, smooth);
      }

      // Unified entry point. realIdx 0 = dpack, 1..N-1 = flavor.
      // For dpack we drive the page-scroll-to-top + bar centering
      // directly; for flavors we delegate to the existing
      // switchToFlavorMobile → syncMobileActive → _centerPillInBar chain
      // (which transparently handles bar scroll + state for us).
      function navigateTo(realIdx) {
        if (realIdx === 0) {
          activeRealIdx = 0;
          updateActiveOnPills(0);
          scrollToMiddleReal(0, true);
          if (!section._dpackActive) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        } else {
          var flavorIdx = realIdx - 1;
          switchToFlavorMobile(section, flavors, navItems, flavorPills, flavorIdx);
        }
      }

      // Tap any pill (real or clone) → navigate to its real flavor.
      for (var pi = 0; pi < allPills.length; pi++) {
        (function (pill) {
          pill.addEventListener('click', function (e) {
            e.preventDefault();
            if (!isMobile()) return;
            var idx = allPills.indexOf(pill);
            var realIdx = idx % N;
            if (realIdx === activeRealIdx && realIdx !== 0) return;
            navigateTo(realIdx);
          });
        })(allPills[pi]);
      }

      // Arrow buttons cycle modulo N (circular both ways).
      if (arrowPrev) {
        arrowPrev.addEventListener('click', function (e) {
          e.preventDefault();
          if (!isMobile()) return;
          navigateTo((activeRealIdx - 1 + N) % N);
        });
      }
      if (arrowNext) {
        arrowNext.addEventListener('click', function (e) {
          e.preventDefault();
          if (!isMobile()) return;
          navigateTo((activeRealIdx + 1) % N);
        });
      }

      // Swipe handler — debounced scroll-settle. If centered pill is in
      // an edge block (0 or 2), instant-jump scrollLeft to the middle
      // block's equivalent pill (visually seamless since neighbors match).
      // Then, if the realIdx changed, trigger navigation.
      scroller.addEventListener('scroll', function () {
        if (programmatic) return;
        if (!isMobile()) return;
        if (scrollTimer) clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          if (programmatic) return;
          var centered = detectCenteredPill();
          if (!centered) return;
          var idx = allPills.indexOf(centered);
          var realIdx = idx % N;
          var block = Math.floor(idx / N);
          if (block !== 1) {
            scrollToAllIdx(N + realIdx, false);
          }
          if (realIdx !== activeRealIdx) {
            navigateTo(realIdx);
          }
        }, 130);
      });

      // _centerPillInBar — public API called by syncMobileActive each
      // time a flavor change settles (no matter the origin: tap, arrow,
      // swipe, vertical scroll past dpack). flavorIdx is the index into
      // the flavors array (0..N-2). Maps to realIdx = flavorIdx + 1.
      section._centerPillInBar = function (flavorIdx) {
        if (!isMobile()) return;
        var realIdx = flavorIdx + 1;
        activeRealIdx = realIdx;
        updateActiveOnPills(realIdx);
        scrollToMiddleReal(realIdx, true);
      };

      // _centerDpackInBar — called by setDpackActive(true) so the bar
      // tracks the dpack section becoming visible (e.g. via page scroll
      // to top, independent of the carousel).
      section._centerDpackInBar = function () {
        if (!isMobile()) return;
        activeRealIdx = 0;
        updateActiveOnPills(0);
        scrollToMiddleReal(0, true);
      };

      // Boot in middle block on dpack (the initial active state set by
      // Liquid). Instant scroll — no animation on first paint.
      requestAnimationFrame(function () {
        if (!isMobile()) return;
        updateActiveOnPills(0);
        scrollToMiddleReal(0, false);
      });
    }

    // Bulletproof pill click: ALWAYS swap state first (syncMobileActive),
    // then layer a best-effort CSS animation on top. No locks, no setTimeouts
    // that gate the swap — if anything fails downstream, the visible state
    // still matches the click.
    function switchToFlavorMobile(section, flavors, navItems, pills, idx) {
      section._dpackActive = false;
      var dpackItems = section.querySelectorAll('[data-dpack-nav]');
      for (var di = 0; di < dpackItems.length; di++) dpackItems[di].classList.remove('is-active');

      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var prev = -1;
      for (var ci = 0; ci < flavors.length; ci++) {
        if (flavors[ci].classList.contains('pdp-flavor--active')) {
          prev = ci;
          break;
        }
      }

      // Decide if we should run the entering animation. The flavor MUST be
      // shown either way — animateIn just controls the visual transition.
      var animateIn = !prefersReduced && prev !== -1 && prev !== idx;

      // STEP 1 — always swap. No early returns. No locks.
      syncMobileActive(section, flavors, navItems, pills, idx, animateIn);
      var sectionWrapper = section.closest('[id^="shopify-section-"]') || section;
      window.scrollTo(0, Math.max(0, sectionWrapper.offsetTop - 80));

      // STEP 2 — best-effort animation. If this fails, the swap is already done.
      if (!animateIn) return;
      var incoming = flavors[idx];
      try {
        // Force layout flush so the --entering initial state is committed
        // before we drop the class.
        void incoming.offsetWidth;
        requestAnimationFrame(function () {
          incoming.classList.remove('pdp-flavor--entering');
        });
        // Safety net: if rAF doesn't fire (tab switch, browser quirk),
        // strip --entering after a max delay so the flavor is never stuck
        // invisible. The animation is decoration, the swap is the contract.
        setTimeout(function () {
          incoming.classList.remove('pdp-flavor--entering');
        }, 500);
      } catch (e) {
        // Defensive: any failure → strip the class so the flavor is visible.
        incoming.classList.remove('pdp-flavor--entering');
      }
    }

    // syncMobileActive: instant state swap. ALWAYS makes the requested flavor
    // visible. When animateIn=true, the incoming gets --entering BEFORE --active
    // so its initial state (opacity 0 + translateY) is in place before render;
    // the caller then flushes layout and removes --entering on the next frame.
    function syncMobileActive(section, flavors, navItems, pills, idx, animateIn) {
      for (var i = 0; i < flavors.length; i++) {
        // Always clear --leaving (Build 2c leftover) so it can't persist
        // across swaps and make a flavor permanently invisible.
        flavors[i].classList.remove('pdp-flavor--leaving');
        if (i === idx) {
          // Order matters when animateIn: add --entering before --active so
          // the initial transitioned state is the FIRST computed state of
          // the freshly-displayed element. Otherwise the element renders at
          // its natural state and no transition fires.
          if (animateIn) flavors[i].classList.add('pdp-flavor--entering');
          else flavors[i].classList.remove('pdp-flavor--entering');
          flavors[i].classList.add('pdp-flavor--active');
          flavors[i].classList.remove('pdp-flavor--hidden');
        } else {
          flavors[i].classList.remove('pdp-flavor--active', 'pdp-flavor--entering');
          flavors[i].classList.add('pdp-flavor--hidden');
        }
      }
      if (!section._dpackActive) {
        for (var p = 0; p < pills.length; p++) {
          if (p === idx) {
            pills[p].classList.add('is-active');
            pills[p].setAttribute('aria-selected', 'true');
          } else {
            pills[p].classList.remove('is-active');
            pills[p].setAttribute('aria-selected', 'false');
          }
        }
        for (var n = 0; n < navItems.length; n++) {
          if (n === idx) navItems[n].classList.add('is-active');
          else navItems[n].classList.remove('is-active');
        }
      }

      // Propagate the active flavor's per-instance custom properties
      // (--pdp-bg-start, --pdp-bg-end, --pdp-accent) to the .pdp section
      // so the gradient + accent color extend BEHIND the pills nav (which
      // sits above .pdp-flavor in DOM order), and so SHOP NOW text + any
      // other accent-driven mobile rule stays in sync with the active
      // flavor when the user switches via pills.
      var activeFlavor = flavors[idx];
      if (activeFlavor) {
        var afCS = window.getComputedStyle(activeFlavor);
        var varNames = ['--pdp-bg-start', '--pdp-bg-end', '--pdp-accent'];
        for (var vi = 0; vi < varNames.length; vi++) {
          var v = afCS.getPropertyValue(varNames[vi]).trim();
          if (v) section.style.setProperty(varNames[vi], v);
        }
      }

      // Bidirectional sync: every flavor change (regardless of origin —
      // tap, arrow, swipe, vertical scroll) recenters the pills bar on
      // the new active pill. Defined in setupMobilePills.
      if (typeof section._centerPillInBar === 'function') {
        section._centerPillInBar(idx);
      }
    }

    // Per-flavor buy area: quantity dropdown + click routing (Amazon URL or
    // Shopify cart POST). Each .pdp-buy is independent (its own buy_mode,
    // own options). The dropdown is a custom listbox (a11y: aria-haspopup,
    // aria-expanded, aria-selected, ArrowUp/Down/Esc, click-outside closes).
    function setupBuyArea(section) {
      var buys = Array.prototype.slice.call(section.querySelectorAll('.pdp-buy'));
      buys.forEach(function (buy) { initBuy(buy); });
    }

    function initBuy(buy) {
      var shop = buy.querySelector('.pdp-shop');
      if (!shop) return;
      var mode = shop.getAttribute('data-buy-mode') || 'amazon';
      var trigger = buy.querySelector('.pdp-pack');
      var menu = buy.querySelector('.pdp-pack-menu');
      var hasDropdown = !!(trigger && menu);

      if (hasDropdown) {
        wireDropdown(buy, trigger, menu, shop, mode);
      }

      // Shopify modes: intercept click on SHOP NOW and POST to /cart/add.js
      // when we have a variant ID. shopify-product = Pass B (product-linked
      // variants resolved server-side, price + cart wired). shopify = legacy
      // textarea variant IDs. Amazon mode: native <a target="_blank">, untouched.
      if (mode === 'shopify' || mode === 'shopify-product') {
        shop.addEventListener('click', function (e) {
          if (shop.getAttribute('aria-disabled') === 'true') {
            e.preventDefault();
            return;
          }
          var variantId = shop.getAttribute('data-variant-id');
          if (!variantId) return; // fallback: let link navigate to shop_url/href
          e.preventDefault();
          shopifyAddToCart(variantId);
        });
      }
    }

    function wireDropdown(buy, trigger, menu, shop, mode) {
      var options = Array.prototype.slice.call(menu.querySelectorAll('[role="option"]'));
      if (options.length === 0) return;
      var countEl = trigger.querySelector('.pdp-pack-count');
      var priceEl = buy.querySelector('[data-pdp-price]');
      var unavailMsg = buy.getAttribute('data-unavailable-message') || '';
      var fallbackHref = buy.getAttribute('data-fallback-href') || shop.getAttribute('href') || '#';

      function setSelected(opt) {
        // shopify-product mode: never let the user "select" an unavailable
        // variant as the active one — keep it visible in the menu (with
        // " (bientôt)" suffix) but skip the swap. Legacy modes have no
        // availability concept so they always proceed.
        if (mode === 'shopify-product' && opt.getAttribute('data-available') === 'false') return;

        options.forEach(function (o) {
          o.setAttribute('aria-selected', o === opt ? 'true' : 'false');
        });
        if (countEl) countEl.textContent = opt.getAttribute('data-label') || '';

        if (mode === 'shopify-product') {
          var variantId = opt.getAttribute('data-variant-id') || '';
          var price = opt.getAttribute('data-price') || '';
          var available = opt.getAttribute('data-available') !== 'false';
          if (priceEl && price) priceEl.textContent = price;
          if (variantId) shop.setAttribute('data-variant-id', variantId);
          else shop.removeAttribute('data-variant-id');
          if (available) {
            shop.removeAttribute('aria-disabled');
            shop.removeAttribute('title');
          } else {
            shop.setAttribute('aria-disabled', 'true');
            if (unavailMsg) shop.setAttribute('title', unavailMsg);
          }
          return;
        }

        // Legacy modes (amazon / shopify): data-target holds Amazon URL or
        // Shopify variant ID depending on mode.
        var target = opt.getAttribute('data-target') || '';
        if (mode === 'amazon') {
          shop.setAttribute('href', target || fallbackHref);
          shop.removeAttribute('data-variant-id');
        } else {
          if (target) {
            shop.setAttribute('data-variant-id', target);
            shop.setAttribute('href', fallbackHref || '/cart');
          } else {
            shop.removeAttribute('data-variant-id');
            shop.setAttribute('href', fallbackHref || '#');
          }
        }
      }

      function open() {
        menu.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        var sel = menu.querySelector('[aria-selected="true"]') || options[0];
        if (sel) sel.focus();
      }
      function close(focusTrigger) {
        menu.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        if (focusTrigger) trigger.focus();
      }
      function isOpen() { return trigger.getAttribute('aria-expanded') === 'true'; }

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (isOpen()) close(false);
        else open();
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (!isOpen()) open();
        } else if (e.key === 'Escape' && isOpen()) {
          e.preventDefault();
          close(true);
        }
      });

      options.forEach(function (opt, idx) {
        opt.addEventListener('click', function (e) {
          e.preventDefault();
          setSelected(opt);
          close(true);
        });
        opt.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setSelected(opt);
            close(true);
          } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            var next = options[Math.min(idx + 1, options.length - 1)];
            if (next) next.focus();
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            var prev = options[Math.max(idx - 1, 0)];
            if (prev) prev.focus();
          } else if (e.key === 'Home') {
            e.preventDefault();
            options[0].focus();
          } else if (e.key === 'End') {
            e.preventDefault();
            options[options.length - 1].focus();
          } else if (e.key === 'Escape') {
            e.preventDefault();
            close(true);
          } else if (e.key === 'Tab') {
            close(false);
          }
        });
      });

      document.addEventListener('click', function (e) {
        if (!isOpen()) return;
        if (!buy.contains(e.target)) close(false);
      });

      // Initialize href/data-variant-id from the pre-selected option.
      var initial = menu.querySelector('[aria-selected="true"]') || options[0];
      if (initial) setSelected(initial);
    }

    function shopifyAddToCart(variantId) {
      var fallback = function () { window.location.href = '/cart'; };
      var notify = function () {
        try {
          window.dispatchEvent(new CustomEvent('cart:added', {
            detail: { variantId: variantId }
          }));
        } catch (err) {
          fallback();
        }
      };
      if (!window.fetch) { fallback(); return; }
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      }).then(function (res) {
        if (!res || !res.ok) { fallback(); return; }
        notify();
      }, fallback);
    }

    function setupPin(section, flavors, navItems) {
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReduced || flavors.length < 2) {
        enterFallback(section, flavors, navItems);
        return;
      }
      if (window.gsap && window.ScrollTrigger) {
        runPin(section, flavors, navItems);
        return;
      }
      window.addEventListener('load', function onLoad() {
        window.removeEventListener('load', onLoad);
        // CRITICAL: re-check viewport at load time. setupPin may have been
        // called when isMobile() was false (e.g. initial layout race before
        // the viewport stabilized). If we're actually mobile by now, switch
        // OVER to mobile mode here — otherwise neither pin nor mobile state
        // would be applied (pin gated out by runPin's isMobile check;
        // applyMobileMode never called because the initial branch went
        // desktop).
        if (isMobile()) {
          applyMobileMode(section, flavors, navItems);
          return;
        }
        if (window.gsap && window.ScrollTrigger) {
          runPin(section, flavors, navItems);
        } else {
          enterFallback(section, flavors, navItems);
        }
      });
    }

    function enterFallback(section, flavors, navItems) {
      // No pin. Nav visibility already wired (footer IO) in initPdp.
      observeFlavors(flavors, navItems);
    }

    function runPin(section, flavors, navItems) {
      // Final gate: refuse to set up the pin if the viewport is mobile,
      // regardless of how we got called. Belt + suspenders against any
      // deferred load listener or async race calling runPin after mobile
      // mode took over.
      if (isMobile()) return;
      if (section.dataset.pdpPinInit === 'true') return;
      section.dataset.pdpPinInit = 'true';

      section.classList.add('pdp--pinned');

      var gsap = window.gsap;
      var ScrollTrigger = window.ScrollTrigger;
      gsap.registerPlugin(ScrollTrigger);
      ScrollTrigger.config({ ignoreMobileResize: true });

      var n = flavors.length;
      // Hero (title + buy + deco) stays put. We translate ONLY .pdp-lower-inner
      // inside its clipping container .pdp-lower → items slide up and disappear
      // under the deco bar instead of overlapping the hero.
      var lowerInners = [];
      var lowerContainers = [];
      // .pdp-can-anchor is translated independently during the wipe so the
      // OUTGOING can slides up off-screen while the incoming flavor wipes in.
      var canAnchors = [];
      for (var i = 0; i < n; i++) {
        lowerInners.push(flavors[i].querySelector('.pdp-lower-inner'));
        lowerContainers.push(flavors[i].querySelector('.pdp-lower'));
        canAnchors.push(flavors[i].querySelector('.pdp-can-anchor'));
      }
      var navEl = section.querySelector('.pdp-nav');

      var fromClip = 'inset(100% 0% 0% 0%)';
      var toClip = 'inset(0% 0% 0% 0%)';

      // Initial state: first flavor revealed, rest hidden + layered above.
      gsap.set(flavors[0], { clipPath: toClip, webkitClipPath: toClip, zIndex: 1 });
      for (var ii = 1; ii < n; ii++) {
        gsap.set(flavors[ii], { clipPath: fromClip, webkitClipPath: fromClip, zIndex: ii + 1 });
      }
      for (var jj = 0; jj < n; jj++) {
        if (lowerInners[jj]) gsap.set(lowerInners[jj], { y: 0 });
        if (canAnchors[jj]) gsap.set(canAnchors[jj], { y: 0 });
      }

      function lectureDist(idx) {
        var inner = lowerInners[idx];
        var container = lowerContainers[idx];
        if (!inner || !container) return 0;
        // Distance the inner content must translate up so its bottom reaches
        // the bottom of the clipping container.
        return Math.max(0, inner.scrollHeight - container.clientHeight);
      }
      // HOLD: small "stillness" segment between lecture and wipe — the pause.
      function holdDist() { return 0.3 * window.innerHeight; }
      // WIPE: shortened scroll so the transition plays "d'un coup" (snappy).
      function wipeDist() { return 0.3 * window.innerHeight; }
      // Distance the outgoing can slides up during the wipe (clears viewport).
      function canSlideDistance() { return 1.2 * window.innerHeight; }

      // GSAP function-values re-evaluated on invalidateOnRefresh — accordion toggle
      // / resize → distances recomputed.
      var phases = [];
      function buildPhases() {
        var arr = [];
        var accum = 0;
        for (var i = 0; i < n; i++) {
          var ld = lectureDist(i);
          arr.push({ type: 'lecture', flavorIdx: i, startPx: accum, endPx: accum + ld, dist: ld });
          accum += ld;
          if (i < n - 1) {
            var hd = holdDist();
            arr.push({ type: 'hold', flavorIdx: i, startPx: accum, endPx: accum + hd, dist: hd });
            accum += hd;
            var wd = wipeDist();
            arr.push({ type: 'wipe', flavorIdx: i + 1, startPx: accum, endPx: accum + wd, dist: wd });
            accum += wd;
          }
        }
        return arr;
      }
      function totalScroll() {
        var sum = 0;
        for (var i = 0; i < n; i++) sum += lectureDist(i);
        sum += (n - 1) * (holdDist() + wipeDist());
        return sum;
      }

      function flavorStartPx(idx) {
        var sum = 0;
        for (var i = 0; i < idx; i++) {
          sum += lectureDist(i);
          sum += holdDist();
          sum += wipeDist();
        }
        return sum;
      }
      section._pdpFlavorStartPx = flavorStartPx;

      function applyState(px) {
        if (!phases.length) phases = buildPhases();
        var lastActive = 0;
        for (var p = 0; p < phases.length; p++) {
          var phase = phases[p];
          if (px < phase.endPx || (phase.dist === 0 && px <= phase.startPx)) {
            var localProgress = phase.dist > 0
              ? Math.max(0, Math.min(1, (px - phase.startPx) / phase.dist))
              : 0;

            // Earlier flavors: revealed + content fully scrolled + can at rest.
            for (var aa = 0; aa < phase.flavorIdx; aa++) {
              gsap.set(flavors[aa], { clipPath: toClip, webkitClipPath: toClip });
              if (lowerInners[aa]) gsap.set(lowerInners[aa], { y: -lectureDist(aa) });
              if (canAnchors[aa]) gsap.set(canAnchors[aa], { y: 0 });
            }

            if (phase.type === 'lecture') {
              gsap.set(flavors[phase.flavorIdx], { clipPath: toClip, webkitClipPath: toClip });
              if (lowerInners[phase.flavorIdx]) {
                gsap.set(lowerInners[phase.flavorIdx], { y: -lectureDist(phase.flavorIdx) * localProgress });
              }
              if (canAnchors[phase.flavorIdx]) gsap.set(canAnchors[phase.flavorIdx], { y: 0 });
              lastActive = phase.flavorIdx;
            } else if (phase.type === 'hold') {
              // Hold: freeze end-of-lecture state. Lower fully scrolled, can centered.
              gsap.set(flavors[phase.flavorIdx], { clipPath: toClip, webkitClipPath: toClip });
              if (lowerInners[phase.flavorIdx]) {
                gsap.set(lowerInners[phase.flavorIdx], { y: -lectureDist(phase.flavorIdx) });
              }
              if (canAnchors[phase.flavorIdx]) gsap.set(canAnchors[phase.flavorIdx], { y: 0 });
              lastActive = phase.flavorIdx;
            } else {
              // wipe: phase.flavorIdx = incoming flavor. Outgoing = phase.flavorIdx - 1.
              var outIdx = phase.flavorIdx - 1;
              // Outgoing: content stays at end-scroll, can slides UP off-screen.
              if (lowerInners[outIdx]) gsap.set(lowerInners[outIdx], { y: -lectureDist(outIdx) });
              if (canAnchors[outIdx]) {
                gsap.set(canAnchors[outIdx], { y: -localProgress * canSlideDistance() });
              }
              // Incoming: clip-path reveals top → bottom; lower content at start; can centered.
              var topInsetPct = (1 - localProgress) * 100;
              gsap.set(flavors[phase.flavorIdx], {
                clipPath: 'inset(' + topInsetPct + '% 0% 0% 0%)',
                webkitClipPath: 'inset(' + topInsetPct + '% 0% 0% 0%)'
              });
              if (lowerInners[phase.flavorIdx]) gsap.set(lowerInners[phase.flavorIdx], { y: 0 });
              if (canAnchors[phase.flavorIdx]) gsap.set(canAnchors[phase.flavorIdx], { y: 0 });
              lastActive = phase.flavorIdx;
            }

            // Later flavors hidden.
            for (var bb = phase.flavorIdx + 1; bb < n; bb++) {
              gsap.set(flavors[bb], { clipPath: fromClip, webkitClipPath: fromClip });
              if (lowerInners[bb]) gsap.set(lowerInners[bb], { y: 0 });
              if (canAnchors[bb]) gsap.set(canAnchors[bb], { y: 0 });
            }
            updateHighlight(lastActive);
            return;
          }
        }
        // Past all phases — clamp to final state.
        for (var cc = 0; cc < n; cc++) {
          gsap.set(flavors[cc], { clipPath: toClip, webkitClipPath: toClip });
          if (lowerInners[cc]) gsap.set(lowerInners[cc], { y: -lectureDist(cc) });
          if (canAnchors[cc]) gsap.set(canAnchors[cc], { y: 0 });
        }
        updateHighlight(n - 1);
      }

      function updateHighlight(idx) {
        if (section._dpackActive) {
          for (var i = 0; i < navItems.length; i++) {
            navItems[i].classList.remove('is-active');
          }
          return;
        }
        for (var i = 0; i < navItems.length; i++) {
          if (i === idx) navItems[i].classList.add('is-active');
          else navItems[i].classList.remove('is-active');
        }
      }

      // Scroll to a flavor.
      //   opts.skipPrevious=false (default): smooth scroll from current scroll
      //     position to the target. Used by the frontier snap (sequential
      //     scroll between adjacent flavors).
      //   opts.skipPrevious=true: instant jump to right before the wipe that
      //     brings the target, then smooth scroll ONLY through the wipe. Used
      //     by nav clicks so the user never sees the current flavor's content
      //     scroll past — also skips any intermediate flavors.
      function scrollToFlavor(idx, opts) {
        if (idx < 0 || idx >= n) return;
        if (!section._pdpST) return;
        var st = section._pdpST;
        var targetPx = Math.round(st.start + flavorStartPx(idx));
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var skipPrevious = opts && opts.skipPrevious;

        // Lock the frontier snap during this transition + disarm any pending
        // armed state — the instant jump would otherwise trip phantom snaps.
        snapUntil = Date.now() + 2000;
        disarm();

        if (skipPrevious) {
          if (idx === 0) {
            // First flavor has no preceding wipe → just jump.
            window.scrollTo(0, targetPx);
            return;
          }
          // Instant jump to start of wipe(idx-1 → idx), then smooth through it.
          var jumpPx = Math.round(targetPx - wipeDist());
          window.scrollTo(0, jumpPx);
          if (reduced) {
            window.scrollTo(0, targetPx);
            return;
          }
          // Wait one frame so ScrollTrigger settles on the jump before the
          // smooth scroll re-engages it.
          requestAnimationFrame(function () {
            smoothScrollTo(targetPx, 700);
          });
          return;
        }

        // Default: smooth from current position (frontier snap path).
        if (reduced) { window.scrollTo(0, targetPx); return; }
        smoothScrollTo(targetPx, 1400);
      }
      section._pdpScrollToFlavor = scrollToFlavor;

      // Frontier-snap state machine:
      //   1. User reaches lecture end → ARM: clamp scroll at the boundary,
      //      cooldown 450ms during which forward pushes are ignored (clamped
      //      back). User sees the bottom of the content, paused.
      //   2. After cooldown, the NEXT forward push triggers the smooth scroll
      //      to the next flavor (= same behavior as clicking the sidebar).
      //   3. Backward scroll past a back-threshold disarms.
      // Symmetric in the upward direction.
      var prevPx = -1;
      var snapUntil = 0;
      var armed = false;
      var armedTarget = -1;     // flavor idx to snap to (when fired)
      var armedDir = '';        // 'down' | 'up'
      var armedAt = 0;
      var armedClampPx = 0;
      var COOLDOWN_MS = 280;
      var DISARM_BACK_PX = 30;
      function disarm() {
        armed = false;
        armedTarget = -1;
        armedDir = '';
        armedAt = 0;
        armedClampPx = 0;
      }

      var stackEl = section.querySelector('.pdp-stack') || section;
      var st = ScrollTrigger.create({
        trigger: stackEl,
        start: 'top top',
        end: function () { return '+=' + totalScroll() + 'px'; },
        pin: stackEl,
        pinSpacing: true,
        // 0.5: wipe tracks the programmatic snap-scroll tightly so the wipe and
        // the glide read as ONE motion (scrub:1 let the wipe trail ~1s behind,
        // which made the transition feel like two decoupled steps).
        scrub: 0.5,
        invalidateOnRefresh: true,
        anticipatePin: 1,
        // Nav visible by default; only hide when leaving the section in either
        // direction. show callbacks remove the hidden class if we re-enter.
        // Nav visibility is driven by a footer IntersectionObserver in
        // setupNavVisibility() (called from initPdp). Doesn't depend on the
        // pin/wipe ScrollTrigger at all — robust to pin-spacer quirks.
        onRefresh: function () {
          phases = buildPhases();
          // Distances changed (accordion toggle / resize). Reset boundary
          // tracking + disarm so stale state doesn't trigger a phantom snap.
          prevPx = -1;
          disarm();
        },
        onUpdate: function (self) {
          var px = self.progress * (self.end - self.start);
          applyState(px);

          // Skip frontier logic under reduced motion or during a snap-in-flight.
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            disarm();
            prevPx = px;
            return;
          }
          if (Date.now() < snapUntil) {
            prevPx = px;
            return;
          }
          if (prevPx < 0) {
            prevPx = px;
            return;
          }

          // ARMED state: clamp at boundary, wait for cooldown, then fire on
          // next push in the armed direction.
          if (armed) {
            var elapsed = Date.now() - armedAt;
            if (armedDir === 'down') {
              if (px > armedClampPx + 1) {
                if (elapsed < COOLDOWN_MS) {
                  // Cooldown: clamp back, user "feels the wall".
                  window.scrollTo(0, Math.round(self.start + armedClampPx));
                  prevPx = armedClampPx;
                  return;
                }
                // Cooldown done + forward push → fire snap.
                snapUntil = Date.now() + 2000;
                var t = armedTarget;
                disarm();
                scrollToFlavor(t);
                prevPx = px;
                return;
              }
              if (px < armedClampPx - DISARM_BACK_PX) {
                disarm();
              }
            } else { // 'up'
              if (px < armedClampPx - 1) {
                if (elapsed < COOLDOWN_MS) {
                  window.scrollTo(0, Math.round(self.start + armedClampPx));
                  prevPx = armedClampPx;
                  return;
                }
                snapUntil = Date.now() + 2000;
                var t2 = armedTarget;
                disarm();
                scrollToFlavor(t2);
                prevPx = px;
                return;
              }
              if (px > armedClampPx + DISARM_BACK_PX) {
                disarm();
              }
            }
            prevPx = px;
            return;
          }

          // NOT armed: detect crossing.
          var dy = px - prevPx;
          if (dy > 0) {
            for (var i = 0; i < n - 1; i++) {
              var lectureEnd = flavorStartPx(i) + lectureDist(i);
              if (prevPx <= lectureEnd && px > lectureEnd) {
                armed = true;
                armedDir = 'down';
                armedTarget = i + 1;
                armedAt = Date.now();
                armedClampPx = lectureEnd;
                window.scrollTo(0, Math.round(self.start + lectureEnd));
                prevPx = lectureEnd;
                return;
              }
            }
          } else if (dy < 0) {
            for (var j = n - 1; j >= 1; j--) {
              var thisStart = flavorStartPx(j);
              if (prevPx >= thisStart && px < thisStart) {
                armed = true;
                armedDir = 'up';
                armedTarget = j - 1;
                armedAt = Date.now();
                armedClampPx = thisStart;
                window.scrollTo(0, Math.round(self.start + thisStart));
                prevPx = thisStart;
                return;
              }
            }
          }
          prevPx = px;
        }
      });

      // Apply initial state at progress 0 — onUpdate doesn't fire until the
      // first scroll change, so the first nav item (Berry) wouldn't be marked
      // .is-active on load otherwise. applyState builds phases lazily if needed.
      applyState(0);
      section._pdpST = st;

      // Accordion toggle → refresh (content height changes).
      var details = section.querySelectorAll('details');
      for (var d = 0; d < details.length; d++) {
        details[d].addEventListener('toggle', function () { ScrollTrigger.refresh(); });
      }

      var refresh = debounce(function () { ScrollTrigger.refresh(); }, 200);
      window.addEventListener('resize', refresh);
      window.addEventListener('orientationchange', refresh);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', refresh);
      }
    }

    // Footer-aware nav visibility. Default = visible (CSS). We only hide the
    // nav when the global footer enters the viewport. Independent of the
    // pin/wipe ScrollTrigger → no pin-spacer / isActive quirks.
    function setupNavVisibility(section) {
      var nav = section.querySelector('.pdp-nav');
      var pills = section.querySelector('.pdp-pills');
      if (!nav && !pills) return;
      if (!('IntersectionObserver' in window)) return;

      // The nav (desktop sidebar) and pills (mobile bar) must stay visible the
      // ENTIRE time the user is within the products zone — the Discovery Pack
      // section PLUS this PDP section — and hide only once BOTH have left the
      // viewport (i.e. the footer has arrived). The previous approach observed
      // the footer directly, which was fragile: the footer's decorative curve
      // / top band, or a short flavor, could trip `isIntersecting` while the
      // user was still mid-content, hiding the bar too early. Tracking the
      // product sections' own visibility is robust — the bar can only hide
      // when neither product section is on screen anymore.
      var zone = [];
      var dpack = document.querySelector('.dpack');
      if (dpack) zone.push(dpack);
      zone.push(section);

      // Map<Element, bool> of each zone section's current intersection state.
      var intersecting = new Map();
      zone.forEach(function (el) { intersecting.set(el, false); });

      function apply() {
        var anyVisible = false;
        intersecting.forEach(function (v) { if (v) anyVisible = true; });
        if (anyVisible) {
          if (nav) nav.classList.remove('pdp-nav--hidden');
          if (pills) pills.classList.remove('pdp-pills--hidden');
        } else {
          if (nav) nav.classList.add('pdp-nav--hidden');
          if (pills) pills.classList.add('pdp-pills--hidden');
        }
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          intersecting.set(entry.target, entry.isIntersecting);
        });
        apply();
      }, { threshold: 0 });
      zone.forEach(function (el) { observer.observe(el); });
    }

    function setupDpackNav(section) {
      var dpack = document.querySelector('.dpack');
      if (!dpack) { section._dpackActive = false; return; }
      var dpackEls = Array.prototype.slice.call(section.querySelectorAll('[data-dpack-nav]'));
      if (dpackEls.length === 0) return;

      var flavorNavItems = Array.prototype.slice.call(section.querySelectorAll('.pdp-nav-item:not([data-dpack-nav])'));
      // :not([data-clone]) filters out the carousel clones — only the real
      // 3 flavor pills (middle DOM block) are addressed for active state.
      var flavorPills = Array.prototype.slice.call(section.querySelectorAll('.pdp-pill:not([data-dpack-nav]):not([data-clone])'));
      var pillsContainer = section.querySelector('.pdp-pills');

      function scrollToDpack(e) {
        e.preventDefault();
        e.stopPropagation();
        window.scrollTo({ top: 0, behavior: 'instant' });
        requestAnimationFrame(function () {
          window.scrollTo({ top: 0, behavior: 'instant' });
        });
      }

      dpackEls.forEach(function (el) {
        el.addEventListener('click', scrollToDpack);
        var link = el.querySelector('.pdp-nav-link');
        if (link) link.addEventListener('click', scrollToDpack);
      });

      function setDpackActive(active) {
        section._dpackActive = active;
        if (active) {
          dpackEls.forEach(function (el) { el.classList.add('is-active'); });
          flavorNavItems.forEach(function (el) { el.classList.remove('is-active'); });
          flavorPills.forEach(function (el) { el.classList.remove('is-active'); });
          // Carousel bar follows: center on the (middle) dpack pill.
          if (typeof section._centerDpackInBar === 'function') {
            section._centerDpackInBar();
          } else if (pillsContainer) {
            pillsContainer.scrollLeft = 0;
          }
        } else {
          dpackEls.forEach(function (el) { el.classList.remove('is-active'); });
          var allFlavors = section.querySelectorAll('.pdp-flavor');
          var activeIdx = 0;
          for (var i = 0; i < allFlavors.length; i++) {
            if (allFlavors[i].classList.contains('pdp-flavor--active')) { activeIdx = i; break; }
          }
          if (flavorPills[activeIdx]) flavorPills[activeIdx].classList.add('is-active');
          if (flavorNavItems[activeIdx]) flavorNavItems[activeIdx].classList.add('is-active');
          // Carousel bar follows: center on the active flavor pill.
          if (typeof section._centerPillInBar === 'function') {
            section._centerPillInBar(activeIdx);
          }
        }
      }

      // Expose for determineActiveAnchor, the single source of truth on
      // mobile (scheduled last from initPdp + driven by scroll below).
      section._applyDpackState = setDpackActive;

      // Desktop initial state from a plain visibility check. On mobile we do
      // NOT pre-write here: the previous synchronous setDpackActive() landed
      // the right state, but later load-time side effects (responsive-mode's
      // setTimeout(0) re-apply → _centerPillInBar) overwrote it back to BERRY.
      // So on mobile the authoritative state is left entirely to
      // determineActiveAnchor, which runs strictly after those writers.
      function isDpackVisibleNow() {
        var rect = dpack.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight);
      }
      if (!isMobile()) setDpackActive(isDpackVisibleNow());

      // Ongoing scroll updates on mobile: the anchor function owns the active
      // state (which section sits at the top of the viewport). rAF-throttled.
      var anchorRaf = null;
      window.addEventListener('scroll', function () {
        if (!isMobile()) return;
        if (anchorRaf) return;
        anchorRaf = requestAnimationFrame(function () {
          anchorRaf = null;
          determineActiveAnchor(section);
        });
      }, { passive: true });

      if (!('IntersectionObserver' in window)) return;
      var observer = new IntersectionObserver(function (entries) {
        // Mobile: defer to anchor determination (single source of truth).
        // Desktop: keep the original intersection-driven dpack toggle.
        if (isMobile()) { determineActiveAnchor(section); return; }
        entries.forEach(function (entry) {
          setDpackActive(entry.isIntersecting);
        });
      }, { threshold: 0.1 });
      observer.observe(dpack);
    }

    function debounce(fn, ms) {
      var t;
      return function () {
        clearTimeout(t);
        t = setTimeout(fn, ms);
      };
    }

    function bindNavClicks(section, navItems) {
      navItems.forEach(function (item, idx) {
        var link = item.querySelector('.pdp-nav-link');
        if (!link) return;
        link.addEventListener('click', function (e) {
          e.preventDefault();
          navigateToFlavor(section, navItems, idx);
        });
      });
    }

    function bindArrows(section, navItems) {
      var arrowUp = section.querySelector('.pdp-nav-arrow--up');
      var arrowDown = section.querySelector('.pdp-nav-arrow--down');

      function activeIndex() {
        for (var i = 0; i < navItems.length; i++) {
          if (navItems[i].classList.contains('is-active')) return i;
        }
        return 0;
      }

      if (arrowUp) {
        arrowUp.addEventListener('click', function () {
          var idx = activeIndex();
          if (idx > 0) navigateToFlavor(section, navItems, idx - 1);
        });
      }
      if (arrowDown) {
        arrowDown.addEventListener('click', function () {
          var idx = activeIndex();
          if (idx < navItems.length - 1) navigateToFlavor(section, navItems, idx + 1);
        });
      }
    }

    function navigateToFlavor(section, navItems, idx) {
      // Nav click: skip the current flavor's lecture entirely. Instant jump to
      // right before the target's wipe, then smooth scroll through that wipe.
      var pinScrollFn = section._pdpScrollToFlavor;
      if (typeof pinScrollFn === 'function') {
        pinScrollFn(idx, { skipPrevious: true });
        return;
      }
      var item = navItems[idx];
      if (item) scrollToId(item.dataset.target);
    }

    // RAF-based smooth scroll with controllable duration + easing. Native
    // window.scrollTo({behavior:'smooth'}) uses a browser-imposed speed that's
    // too snappy for our bascule — this gives us ~1.2s posed glide instead.
    var smoothScrollRaf = null;
    function smoothScrollTo(target, duration) {
      if (smoothScrollRaf) cancelAnimationFrame(smoothScrollRaf);
      smoothScrollRaf = null;
      duration = duration || 1200;
      var startY = window.scrollY;
      var distance = target - startY;
      if (Math.abs(distance) < 1) { window.scrollTo(0, target); return; }
      var startTime = performance.now();
      function step(now) {
        var elapsed = now - startTime;
        var t = Math.min(1, elapsed / duration);
        // sine.inOut equivalent: softest in/out — gentle start, no sharp mid
        // acceleration, gentle settle. Reads as a slow posed glide.
        var eased = -(Math.cos(Math.PI * t) - 1) / 2;
        window.scrollTo(0, Math.round(startY + distance * eased));
        if (t < 1) {
          smoothScrollRaf = requestAnimationFrame(step);
        } else {
          smoothScrollRaf = null;
        }
      }
      smoothScrollRaf = requestAnimationFrame(step);
    }

    function scrollSmoothly(top) {
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) { window.scrollTo(0, top); return; }
      smoothScrollTo(top, 1200);
    }

    function observeFlavors(flavors, navItems) {
      if (!('IntersectionObserver' in window)) {
        if (navItems[0]) navItems[0].classList.add('is-active');
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var id = entry.target.id;
          navItems.forEach(function (item) {
            if (item.dataset.target === id) {
              item.classList.add('is-active');
            } else {
              item.classList.remove('is-active');
            }
          });
        });
      }, {
        rootMargin: '-45% 0px -45% 0px',
        threshold: 0
      });

      flavors.forEach(function (f) { observer.observe(f); });
    }

    function scrollToId(id) {
      var el = document.getElementById(id);
      if (!el) return;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try {
        el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      } catch (e) {
        el.scrollIntoView();
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-flavor"] && !Shopify.designMode) return;
  try {
    
  /* Bloc commerce — JS du sélecteur (ouverture/fermeture du menu déroulant +
     navigation clavier) et de l'ajout panier copié À L'IDENTIQUE du block Berry
     de pdp-flavors.liquid. Adaptations : prix injecté depuis data-price-money
     (chaîne déjà formatée par le filtre money, JAMAIS reformatée en JS) ; bouton
     qui bascule SHOP NOW ↔ SOLD OUT selon la dispo de la variante choisie ;
     toutes les variantes restent sélectionnables. Aucune dépendance GSAP. */
  (function () {
    var buys = Array.prototype.slice.call(
      document.querySelectorAll('.product-flavor .pdp-buy')
    );
    buys.forEach(function (buy) { initBuy(buy); });

    function initBuy(buy) {
      var shop = buy.querySelector('.pdp-shop');
      if (!shop) return;
      var trigger = buy.querySelector('.pdp-pack');
      var menu = buy.querySelector('.pdp-pack-menu');

      if (trigger && menu) {
        wireDropdown(buy, trigger, menu, shop);
      }

      // Clic sur SHOP NOW → POST /cart/add.js avec la variante sélectionnée.
      // Si le bouton est en SOLD OUT (aria-disabled), aucune action.
      shop.addEventListener('click', function (e) {
        if (shop.getAttribute('aria-disabled') === 'true') {
          e.preventDefault();
          return;
        }
        var variantId = shop.getAttribute('data-variant-id');
        if (!variantId) return;
        e.preventDefault();
        shopifyAddToCart(variantId);
      });
    }

    function wireDropdown(buy, trigger, menu, shop) {
      var options = Array.prototype.slice.call(menu.querySelectorAll('[role="option"]'));
      if (options.length === 0) return;
      var countEl = trigger.querySelector('.pdp-pack-count');
      var priceEl = buy.querySelector('[data-pdp-price]');
      var labelEl = shop.querySelector('.pdp-shop-label');
      // Réglage prix en rupture (hide / dash / show), passé par Liquid sur le root.
      var soldOutPrice = buy.getAttribute('data-sold-out-price') || 'hide';

      // Mirror du snippet `pack-label` côté JS : 1er token (taille normale) +
      // reste dans un <span class="pdp-pack-unit"> plus petit. Split générique
      // sur l'espace. Construction DOM (textContent) → pas d'injection HTML.
      function setPackLabel(el, label) {
        el.textContent = '';
        var parts = (label || '').trim().split(/\s+/).filter(Boolean);
        el.appendChild(document.createTextNode(parts.shift() || ''));
        if (parts.length) {
          var unit = document.createElement('span');
          unit.className = 'pdp-pack-unit';
          unit.textContent = parts.join(' ');
          el.appendChild(unit);
        }
      }

      function setSelected(opt) {
        options.forEach(function (o) {
          o.setAttribute('aria-selected', o === opt ? 'true' : 'false');
        });
        if (countEl) setPackLabel(countEl, opt.getAttribute('data-label') || '');

        var available = opt.getAttribute('data-available') !== 'false';

        // Prix : on INJECTE la chaîne déjà formatée par Liquid (filtre money),
        // jamais de formatage / devise en JS. En rupture, le réglage soldOutPrice
        // décide : hide (masqué), dash (« – »), show (prix normal).
        var price = opt.getAttribute('data-price-money') || '';
        if (priceEl) {
          if (available || soldOutPrice === 'show') {
            priceEl.hidden = false;
            if (price) priceEl.textContent = price;
          } else if (soldOutPrice === 'dash') {
            priceEl.hidden = false;
            priceEl.textContent = '–';
          } else {
            priceEl.hidden = true;
          }
        }

        var variantId = opt.getAttribute('data-variant-id') || '';
        if (variantId) shop.setAttribute('data-variant-id', variantId);
        else shop.removeAttribute('data-variant-id');

        // Bouton SHOP NOW (dispo) ↔ SOLD OUT (out of stock).
        if (available) {
          shop.removeAttribute('aria-disabled');
          if (labelEl) labelEl.textContent = 'SHOP NOW';
        } else {
          shop.setAttribute('aria-disabled', 'true');
          if (labelEl) labelEl.textContent = 'SOLD OUT';
        }
      }

      function open() {
        menu.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        var sel = menu.querySelector('[aria-selected="true"]') || options[0];
        if (sel) sel.focus();
      }
      function close(focusTrigger) {
        menu.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        if (focusTrigger) trigger.focus();
      }
      function isOpen() { return trigger.getAttribute('aria-expanded') === 'true'; }

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (isOpen()) close(false);
        else open();
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (!isOpen()) open();
        } else if (e.key === 'Escape' && isOpen()) {
          e.preventDefault();
          close(true);
        }
      });

      options.forEach(function (opt, idx) {
        opt.addEventListener('click', function (e) {
          e.preventDefault();
          setSelected(opt);
          close(true);
        });
        opt.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setSelected(opt);
            close(true);
          } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            var next = options[Math.min(idx + 1, options.length - 1)];
            if (next) next.focus();
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            var prev = options[Math.max(idx - 1, 0)];
            if (prev) prev.focus();
          } else if (e.key === 'Home') {
            e.preventDefault();
            options[0].focus();
          } else if (e.key === 'End') {
            e.preventDefault();
            options[options.length - 1].focus();
          } else if (e.key === 'Escape') {
            e.preventDefault();
            close(true);
          } else if (e.key === 'Tab') {
            close(false);
          }
        });
      });

      document.addEventListener('click', function (e) {
        if (!isOpen()) return;
        if (!buy.contains(e.target)) close(false);
      });

      // Initialise prix / variante / état du bouton depuis l'option pré-sélectionnée.
      var initial = menu.querySelector('[aria-selected="true"]') || options[0];
      if (initial) setSelected(initial);
    }

    function shopifyAddToCart(variantId) {
      var fallback = function () { window.location.href = '/cart'; };
      var notify = function () {
        try {
          var evt = new CustomEvent('cart:added', { detail: { variantId: variantId } });
          // Le cart-drawer écoute sur window ; on émet aussi sur document.
          window.dispatchEvent(evt);
          document.dispatchEvent(new CustomEvent('cart:added', { detail: { variantId: variantId } }));
        } catch (err) {
          fallback();
        }
      };
      if (!window.fetch) { fallback(); return; }
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      }).then(function (res) {
        if (!res || !res.ok) { fallback(); return; }
        notify();
      }, fallback);
    }
  })();

  /* Popup « valeurs nutritionnelles » — <dialog> modal natif. Le lien l'ouvre via
     showModal() (qui gère nativement la capture/restitution du focus ET la touche
     Échap → événement 'cancel'). Fermeture explicite via la croix et via un clic
     sur le backdrop (cible du clic = le <dialog> lui-même, jamais le panneau
     intérieur). Repli sur l'attribut [open] si showModal n'existe pas. Vanille,
     zéro GSAP, cohérent avec le JS du sélecteur ci-dessus. */
  (function () {
    var sections = Array.prototype.slice.call(
      document.querySelectorAll('.product-flavor')
    );
    sections.forEach(function (section) {
      var openBtn = section.querySelector('[data-nutrition-open]');
      var dialog = section.querySelector('.product-flavor__nutrition-dialog');
      if (!openBtn || !dialog) return;
      var closeBtn = dialog.querySelector('[data-nutrition-close]');

      function open() {
        if (typeof dialog.showModal === 'function') {
          if (!dialog.open) dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      }
      function close() {
        if (typeof dialog.close === 'function' && dialog.open) dialog.close();
        else dialog.removeAttribute('open');
      }

      openBtn.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          close();
        });
      }

      // Clic sur le backdrop → la cible est le <dialog> lui-même (le panneau
      // intérieur intercepte les clics du contenu). Ferme.
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) close();
      });
    });
  })();

  /* Nav latérale desktop (position:fixed, centrée viewport) : on la fait
     disparaître à l'approche du footer pour qu'elle ne s'y superpose pas.
     Bloc autonome — observe le footer et toggle .product-flavor__nav--hidden. */
  (function () {
    var nav = document.querySelector('.product-flavor__nav');
    var footer = document.querySelector('#shopify-section-footer')
              || document.querySelector('footer.footer')
              || document.querySelector('footer');
    if (!nav || !footer || !('IntersectionObserver' in window)) { return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        nav.classList.toggle('product-flavor__nav--hidden', entry.isIntersecting);
      });
    }, { rootMargin: '0px 0px -40% 0px', threshold: 0 });
    io.observe(footer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc"] && !Shopify.designMode) return;
  try {
    
  /* Branchement sur le mécanisme PDP existant (product-flavor.liquid).
     - ADD TO CART = proxy-click sur le bouton principal .product-flavor .pdp-shop
       → réutilise le POST /cart/add.js + dispatch cart:added + garde aria-disabled.
     - SYNC = MutationObserver sur la zone d'achat principale .pdp-buy (variante /
       prix / dispo). C'est la seule source de vérité (pas d'event de variante).
     - APPARITION = IntersectionObserver sur le bouton principal (sort du viewport
       → barre visible). always_visible court-circuite l'observer. */
  (function () {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;

    // Cible principale : zone d'achat + bouton SHOP NOW de product-flavor.
    var mainBuy = document.querySelector('.product-flavor .pdp-buy');
    var mainShop = mainBuy ? mainBuy.querySelector('.pdp-shop') : null;
    if (!mainBuy || !mainShop) {
      // Aucun mécanisme d'achat direct sur cette PDP → on n'affiche pas la barre.
      // (Sur ce thème la PDP product-flavor a toujours SHOP NOW = ajout direct.)
      return;
    }

    var posDesktop = bar.getAttribute('data-position-desktop') === 'top' ? 'top' : 'bottom';
    var posMobile = bar.getAttribute('data-position-mobile') === 'top' ? 'top' : 'bottom';
    var alwaysVisible = bar.getAttribute('data-always-visible') === 'true';

    var btn = bar.querySelector('[data-satc-add]');
    var labelEl = bar.querySelector('[data-satc-label]');
    var priceEl = bar.querySelector('[data-satc-price]');
    var variantEl = bar.querySelector('[data-satc-variant]');

    var mq = window.matchMedia('(max-width: 767px)');

    // Position : applique top/bottom selon le viewport (desktop vs mobile).
    function applyPosition() {
      var pos = mq.matches ? posMobile : posDesktop;
      bar.classList.remove('sticky-atc--top', 'sticky-atc--bottom');
      bar.classList.add(pos === 'top' ? 'sticky-atc--top' : 'sticky-atc--bottom');
    }

    // Reflète l'accent de la saveur (var --pf-gradient-end de .product-flavor)
    // sur le bouton, pour que le texte ADD TO CART matche la saveur courante.
    function syncAccent() {
      var pf = document.querySelector('.product-flavor');
      if (!pf) return;
      var accent = window.getComputedStyle(pf).getPropertyValue('--pf-gradient-end').trim();
      if (accent) bar.style.setProperty('--satc-accent', accent);
    }

    // Synchronise variante / prix / dispo depuis la zone d'achat principale.
    function syncFromMain() {
      var mainPrice = mainBuy.querySelector('[data-pdp-price]');
      var mainCount = mainBuy.querySelector('.pdp-pack-count');
      if (priceEl && mainPrice) priceEl.textContent = mainPrice.textContent;
      if (variantEl && mainCount) variantEl.textContent = mainCount.textContent;

      var disabled = mainShop.getAttribute('aria-disabled') === 'true';
      if (disabled) {
        btn.setAttribute('aria-disabled', 'true');
        if (labelEl) labelEl.textContent = 'COMING SOON';
      } else {
        btn.removeAttribute('aria-disabled');
        if (labelEl) labelEl.textContent = 'ADD TO CART';
      }
    }

    // ADD TO CART → proxy-click sur le bouton principal (réutilise tout son handler).
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.getAttribute('aria-disabled') === 'true') return;
      mainShop.click();
    });

    // Observe la zone d'achat : tout changement (variante/prix/dispo) re-synchronise.
    var mo = new MutationObserver(syncFromMain);
    mo.observe(mainBuy, {
      attributes: true,
      attributeFilter: ['data-variant-id', 'aria-disabled'],
      childList: true,
      characterData: true,
      subtree: true
    });

    // Visibilité.
    function show() { bar.classList.add('is-visible'); }
    function hide() { bar.classList.remove('is-visible'); }

    // Déclencheur PAR DEVICE — le layout produit diffère trop pour partager une
    // seule cible :
    //   • DESKTOP : SHOP NOW est haut dans la colonne droite → on l'observe
    //     directement ; la barre apparaît quand il quitte le viewport par le haut.
    //   • MOBILE : SHOP NOW est très bas (layout empilé : titre → canette → prix
    //     → bouton) → l'observer dessus arriverait trop tard. On observe l'élément
    //     HAUT du bloc produit (le titre, juste sous le header) → apparition peu
    //     après le début du scroll. Repli sur SHOP NOW si le titre est absent.
    var mobileTrigger =
      document.querySelector('.product-flavor .product-flavor__title') || mainShop;

    function currentTarget() { return mq.matches ? mobileTrigger : mainShop; }

    // Visibilité BIDIRECTIONNELLE, sans latch : on ré-évalue la position de la
    // cible à CHAQUE scroll / resize (throttle rAF) et on bascule dans les deux
    // sens. Condition : barre visible UNIQUEMENT quand la cible a été scrollée
    // AU-DESSUS du haut du viewport (getBoundingClientRect().top < 0) ; visible
    // ou encore SOUS la ligne de flottaison (top >= 0) → masquée. Donc caché au
    // load ET re-masquée quand on remonte tout en haut.
    // NB : on n'utilise PAS IntersectionObserver ici — avec threshold:0 il ne
    // fire qu'au franchissement du bord et rate la transition top<0 → top>=0
    // (le ratio reste >0 en remontant), ce qui laissait la barre affichée en haut.
    var ticking = false;
    function evaluate() {
      ticking = false;
      if (alwaysVisible) return;
      var target = currentTarget();
      if (!target) { hide(); return; }
      if (target.getBoundingClientRect().top < 0) show();
      else hide();
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(evaluate);
    }

    applyPosition();
    syncAccent();
    syncFromMain();
    bar.removeAttribute('hidden');

    if (alwaysVisible) {
      show();
    } else {
      evaluate(); // état initial (caché au load)
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }

    // Changement de breakpoint : re-applique la position ET ré-évalue avec la
    // bonne cible (currentTarget() lit mq.matches → desktop ↔ mobile).
    function onBreakpointChange() {
      applyPosition();
      evaluate();
    }
    if (mq.addEventListener) mq.addEventListener('change', onBreakpointChange);
    else if (mq.addListener) mq.addListener(onBreakpointChange);
  })();

  } catch(e) { console.error(e); }
})();
})();
